import { render } from "./CardFourty.vue?vue&type=template&id=5a13bc8e"
import script from "./CardFourty.vue?vue&type=script&lang=js"
export * from "./CardFourty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__